import Permissions from '@/permissions'
import List from '@/views/borrows/drafts/List'
import Edit from '@/views/borrows/drafts/Edit'
import Show from '@/views/borrows/drafts/Show'
import Draft from '@/views/borrows/drafts/Index'
import SwitchTableColumn from '@/views/borrows/drafts/SwitchTableColumn'

export const draftRouters = {
  path: 'draft',
  name: 'draft',
  component: Draft,
  redirect: 'draft',
  meta: {
    permissions: [Permissions.backend.draft.manage],
    groups: 'draft'
  },
  children: [
    {
      path: '',
      name: 'list-draft',
      component: List,
      meta: {
        permissions: [Permissions.backend.draft.list],
        groups: 'draft',
        breadcrumb: [
          {
            name_en: 'Draft',
            name_km: 'ការស្នើព្រាង'
          },
          {
            name_en: 'List',
            name_km: 'បញ្ជី'
          }
        ]
      }
    },
    {
      path: 'edit/:borrow_id',
      name: 'edit-draft',
      component: Edit,
      meta: {
        permissions: [Permissions.backend.draft.edit],
        groups: 'draft',
        breadcrumb: [
          {
            name_en: 'Draft',
            name_km: 'ការស្នើព្រាង'
          },
          {
            name_en: 'Edit',
            name_km: 'កែសម្រួល'
          }
        ]
      }
    },
    {
      path: 'show/:borrow_id',
      name: 'show-draft',
      component: Show,
      meta: {
        permissions: [Permissions.backend.draft.show],
        groups: 'draft',
        breadcrumb: [
          {
            name_en: 'Draft',
            name_km: 'ការស្នើព្រាង'
          },
          {
            name_en: 'Show',
            name_km: 'មើល'
          }
        ]
      }
    },
    {
      path: 'switch-table-column-draft',
      name: 'switch-table-column-draft',
      component: SwitchTableColumn,
      meta: {
        permissions: [Permissions.backend.draft.filterColumnTable],
        groups: 'draft',
        breadcrumb: [
          {
            name_en: 'Draft',
            name_km: 'ការស្នើព្រាង'
          },
          {
            name_en: 'Switching table columns',
            name_km: 'ផ្លាស់ប្តូរព័ត៌មាននៃតារាង'
          }
        ]
      }
    }
  ]
}
